<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="!hasImagePhoto"></ya-subheader>
  <div *ngIf="hasImagePhoto" class="aspect-ratio-box">
    <div class="aspect-ratio-box-inside">
      <div class="aspect-ration-img-box">
        <img class="ya_image image" [src]="imagePhoto" rel="preload" alt="Logo" />
      </div>
    </div>
  </div>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <ng-container *ngIf="useWellcomeLabel">
      <div class="title-container" [ngClass]="hasImagePhoto? 'title-margin':''">
        <h2 *ngIf="useWellcomeLabel">{{wellcomeLabel}}</h2>
        <span *ngIf="welcomeSubtext" class="text content-container--subfont">{{welcomeSubtext}}</span>
      </div>
    </ng-container>
    <div class="OrderMode-selector-container">
      <ng-container *ngIf="isLoaded">
        <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToSingleOrder()">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
          </div>
          <div class="content-container">
            <h2 class="title">{{singleOrderTitle}}</h2>
            <div class="text content-container--subfont">{{singleOrderDescription}}</div>
          </div>
        </div>
        <div a11y_Button class="ya-icon-button service-button animate" (click)="navigationToGroupOrder()">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi"></div>
          </div>
          <div class="content-container">
            <h2 class="title">{{groupOrderTitle}}</h2>
            <div class="text content-container--subfont">{{groupOrderDescription}}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>